/**
 * Build app signup URL and merge current page query (e.g. utm_*) so ad params reach the school app.
 * @param {Record<string, string | number | undefined | null>} [extraParams] appends/overrides (e.g. pmid, pname)
 * @returns {string}
 */
export function buildSignupUrlWithMarketingParams(extraParams = {}) {
  const baseUrl = process.env.REACT_APP_URL;
  const url = new URL(`${baseUrl}/auth/signup`);

  if (typeof window !== "undefined") {
    const current = new URLSearchParams(window.location.search);
    current.forEach((value, key) => {
      url.searchParams.set(key, value);
    });
  }

  Object.entries(extraParams).forEach(([key, value]) => {
    if (value != null && value !== "") {
      url.searchParams.set(key, String(value));
    }
  });

  return url.toString();
}

export function openSignupWithMarketingParams(extraParams = {}, windowName = "_blank") {
  const targetUrl = buildSignupUrlWithMarketingParams(extraParams);
  window.open(targetUrl, windowName, "noopener,noreferrer");
}
